<template>
  <div class="compressed-content">
    <h3 class="page-question">For females, do you have any of the following medical conditions?</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.femaleConditions">
      <b-form-checkbox
        v-for="option in options"
        :key="option.key"
        v-model="femaleConditions[option.key]"
        @change="onOptionSelected(option.key, $event)"
      >
        {{ option.label }}
      </b-form-checkbox>
    </v-form-group>
  </div>
</template>

<script>
import formMixin from "mixins/form-mixin";
import { createNamespacedHelpers } from "vuex";
import { anyOptionRequired } from "utils/custom-validators";

const { mapState } = createNamespacedHelpers("survey");

const CONDITION_KEYS = [
  "noCondition",
  "hasEclampsia",
  "hasEOM",
  "hasGestationalHypertension",
  "hasPretermDelivery",
  "hasLowGestationalBirthweight",
  "hasSpontaneousPregnancyLoss",
  "hasEarlyMenarche",
  "hasPCOS"
];

export default {
  mixins: [formMixin],

  data() {
    return {
      options: [
        { key: "noCondition", label: "No" },
        { key: "hasEclampsia", label: "History of preeclampsia or eclampsia" },
        { key: "hasEOM", label: "Menopause before age 40" },
        { key: "hasGestationalHypertension", label: "History of Gestational Hypertension" },
        { key: "hasPretermDelivery", label: "History of Preterm Delivery (before 37 weeks)" },
        { key: "hasLowGestationalBirthweight", label: "History of Small for Gestational Age Birthweight (<10th percentile)" },
        { key: "hasSpontaneousPregnancyLoss", label: "History of Recurrent Spontaneous Pregnancy Loss" },
        { key: "hasEarlyMenarche", label: "History of Early Menarche (<10 years old)" },
        { key: "hasPCOS", label: "History of Polycystic ovarian syndrome (PCOS) and irregular menses" }
      ]
    };
  },

  validations: {
    femaleConditions: {
      anyOptionRequired: anyOptionRequired(value =>
        CONDITION_KEYS.some(key => value[key])
      )
    }
  },

  computed: {
    ...mapState(["survey"]),

    femaleConditions() {
      return this.survey.medicalConditions.femaleConditions;
    }
  },

  methods: {
    onOptionSelected(selectedKey, value) {
      if (selectedKey === "noCondition" && value) {
        CONDITION_KEYS.forEach(key => {
          this.femaleConditions[key] = key === "noCondition";
        });
        return;
      }

      if (selectedKey !== "noCondition") {
        this.femaleConditions.noCondition = false;
        this.femaleConditions[selectedKey] = value;
      }
    }
  }
};
</script>